import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SectionPaper = styled(Paper)(({ theme, overflow }) => (
  {
    ...theme.typography.body2,

    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "flex-start",

    color: theme.palette.text.secondary,
    lineHeight: "60px",

    height: "100%",
    overflow: overflow || "hidden",

    // background: "rgba(255, 255, 255, 0.58)",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.main
        : "rgba(255, 255, 255, 0.58)",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",

    border: `1px solid ${theme.palette.mode === "dark"
      ? theme.palette.background.main
      : "rgba(255, 255, 255, 0.65)"}`,
    borderRadius: "16px",

    boxShadow: `
    0 8px 32px rgba(41, 78, 107, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.7)
  `,

    transition:
      "transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease",

    "&:hover": {
      background: theme.palette.mode === "dark"
        ? theme.palette.background.main
        : "rgba(255, 255, 255, 0.64)",

      boxShadow: `
      0 12px 38px rgba(41, 78, 107, 0.16),
      inset 0 1px 0 ${theme.palette.mode === "dark"
          ? theme.palette.background.main
          : "rgba(255, 255, 255, 0.8)"}
    `,

      transform: "translateY(-2px)",
    },
  }));

// import { Paper } from "@mui/material";
// import { styled } from "@mui/material/styles";

// export const SectionPaper = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   display: "flex",
//   textAlign: "center",
//   justifyContent: "center",
//   alignItems: "flex-start",
//   color: theme.palette.text.secondary,
//   lineHeight: "60px",
//   borderRadius: "16px",
//   height: "100%",
// }));
